import React from 'react';
import Hit from "./hit"
import { useHits } from 'react-instantsearch';
import _ from 'lodash';

const mapCategoryNameToObject = categoryName => window.productCategories
    .find(cat => cat.title === categoryName)

function HitsList(props) {
    const { items } = useHits(props);
    var categories = items
            .map(item => mapCategoryNameToObject(item.productCategories))
            .filter(item => item);
    categories = _.uniqBy(categories, 'title');
    return      <div>
                        {categories.slice(0, 4).map(category => (
                            <Hit
                                key={category.title}
                                title={category.title}
                                image={category.image}
                                absoluteUri={category.absoluteUri}
                            />))}
                </div>;
}
export default HitsList